"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReserveYourExperience() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221543" id="conversão-final" className="bg-background text-foreground relative flex min-h-[60vh] items-center justify-center overflow-hidden py-24 md:py-32 border-t border-[hsl(0,0%,90%)]">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645251/img/minimalist_studio_workspace.png)] bg-cover bg-center opacity-5 mix-blend-multiply blur-[1px]" />
        <div className="absolute inset-0 bg-background" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 mx-auto flex w-full max-w-3xl flex-col items-center px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <span className="mb-4 block text-sm font-medium tracking-widest text-primary uppercase">
          Próximo Passo
        </span>
        
        <h2 className="font-default mb-6 text-4xl font-semibold tracking-tight text-foreground md:text-5xl lg:text-[48px]">
          Pronto para posicionar sua empresa?
        </h2>
        
        <p className="mb-10 max-w-xl text-lg font-normal text-muted-foreground md:text-xl">
          Transforme sua visão em uma presença digital de alto impacto. Fale com nossos especialistas e comece sua evolução hoje.
        </p>
        
        <Button asChild size="lg" className="h-14 px-10 text-base font-medium tracking-wide uppercase shadow-xl transition-all hover:scale-105 bg-primary hover:bg-primary/90 text-primary-foreground rounded-full animate-pulse">
          <Link to="/DigitalPresenceConsultationPage">Fale Com Um Especialista</Link>
        </Button>
      </div>
    </section>;
}